export enum MimeTypes {
  JPEG = "image/jpeg",
  PNG = "image/png",
  GIF = "image/gif",
  PDF = "application/pdf",
  EXCEL = "application/vnd.ms-excel",
  CSV = "text/csv",
  PPT = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}
